import React from 'react';
import LanguageToggle from './LanguageToggle';
import { AboutYouText } from 'src/packages/cli/constants/AboutYouText';
import { Language } from 'src/types/Language';
/** Convert an ITranslatable to a FieldLabel */
export const toFieldLabel = (translatable) => ({
    en: translatable.english,
    es: translatable.spanish,
});
export const resolveLabel = (label) => 'en' in label ? label : toFieldLabel(label);
// export const fieldRequiredMsg = (label: FieldLabelInput) => {
//   const l = resolveLabel(label);
//   return <LanguageToggle en={`${l.en} is required.`} es={`${l.es} es obligatorio.`} />;
// };
export const selectionRequiredMsg = (label) => {
    const l = resolveLabel(label);
    return <LanguageToggle en={`Please select ${l.en}.`} es={`Por favor seleccione ${l.es}.`}/>;
};
export const fieldInvalidMsg = (label) => {
    const l = resolveLabel(label);
    return <LanguageToggle en={`${l.en} is not valid.`} es={`${l.es} no es válido.`}/>;
};
export const nameInvalidMsg = (label) => {
    const l = resolveLabel(label);
    return <LanguageToggle en={`${l.en} is not valid. ${AboutYouText.nameError.english}`} es={`${l.es} no es válido. ${AboutYouText.nameError.spanish}`}/>;
};
export const fieldErrorMsg = (label, enMsg, esMsg) => {
    const l = resolveLabel(label);
    return <LanguageToggle en={`${l.en} ${enMsg}`} es={`${l.es} ${esMsg}`}/>;
};
/** Plain-string variants of the messages above, for inputs whose `validate` must return a string (honest-ui). */
const pickLanguage = (language, en, es) => (language === Language.SPANISH ? es : en);
export const fieldErrorStr = (label, enMsg, esMsg, language) => {
    const l = resolveLabel(label);
    return pickLanguage(language, `${l.en} ${enMsg}`, `${l.es} ${esMsg}`);
};
export const fieldInvalidStr = (label, language) => fieldErrorStr(label, 'is not valid.', 'no es válido.', language);
export const nameInvalidStr = (label, language) => fieldErrorStr(label, `is not valid. ${AboutYouText.nameError.english}`, `no es válido. ${AboutYouText.nameError.spanish}`, language);
/** Plain-string required message matching honest-react's wording ("The x field is required."). */
export const fieldRequiredStr = (label, language) => {
    const l = resolveLabel(label);
    return pickLanguage(language, `The ${l.en.toLowerCase()} field is required.`, `El campo de ${l.es.toLowerCase()} es obligatorio.`);
};
